import PageRoutes from "PageRoutes";
import "asset/reset.css";
import { BrowserRouter as Router } from "react-router-dom";

import { QueryClient, QueryClientProvider } from "react-query";
import { ReactQueryDevtools } from "react-query/devtools";

import { RecoilRoot } from "recoil";

import { MantineProvider } from "@mantine/core";
import { ModalsProvider } from "@mantine/modals";

import logo from "asset/logo.png";
import { Helmet } from "react-helmet-async";

const queryClient = new QueryClient();

function App() {

  // 사용되지 않아 주석 처리
  // const scriptSrcUri =
  //   "http://openapi.map.naver.com"
  //   + " http://nrbe.map.naver.net"
  //   + " http://static.naver.net";

  return (
    <>
      <Helmet>
        <title>SRD_Korea 염수관리 시스템</title>
        <meta property="og:image" content={logo} />
        <meta name="referrer" content="strict-origin-when-cross-origin" />
      </Helmet>
      <QueryClientProvider client={queryClient}>
        <RecoilRoot>
          <MantineProvider>
            <ModalsProvider>
              <Router
                future={{
                  v7_startTransition: true,
                  v7_relativeSplatPath: true,
                }}
              >
                <PageRoutes />
              </Router>
            </ModalsProvider>
          </MantineProvider>
          <ReactQueryDevtools />
        </RecoilRoot>
      </QueryClientProvider>
    </>
  );
}
/*
function App() {

  const scriptSrcUri =
    "http://openapi.map.naver.com"
    + " http://nrbe.map.naver.net"
    + " http://static.naver.net";

  return (
    <>
      <Helmet>
        <title>SRD_Korea 염수관리 시스템</title>
        <meta property="og:image" content={logo} />
        <meta name="referrer" content="strict-origin-when-cross-origin" />
        <meta httpEquiv="Content-Security-Policy"
          content={`
              script-src 'self'  ${scriptSrcUri};
              child-src 'none';
              style-src 'self' 'unsafe-inline';
              media-src 'self';
          `}
        />
      </Helmet>
      <QueryClientProvider client={queryClient}>
        <RecoilRoot>
          <MantineProvider>
            <ModalsProvider>
              <Router>
                <PageRoutes />
              </Router>
            </ModalsProvider>
          </MantineProvider>
          <ReactQueryDevtools />
        </RecoilRoot>
      </QueryClientProvider>
    </>
  );
}
*/
export default App;
